import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { buildQueryParams } from '../../utils/object';

export const smsNotificationApi = createApi({
  reducerPath: 'smsNotificationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  // These rows are written server-side by the Kafka dispatch job, so no client
  // mutation can invalidate them. Refetch on every mount instead of serving a
  // stale cache entry when the user navigates back to the page.
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getSmsNotifications: builder.query({
      query: ({ page, limit, status, from_date, to_date, search } = {}) => ({
        url: 'sms-notifications',
        params: buildQueryParams({
          page,
          limit,
          status,
          from_date,
          to_date,
          search,
        }),
      }),
    }),
    getSmsNotificationSummary: builder.query({
      query: ({ status, from_date, to_date, search } = {}) => ({
        url: 'sms-notifications/summary',
        params: buildQueryParams({ status, from_date, to_date, search }),
      }),
    }),
    getSmsNotificationMeta: builder.query({
      query: () => 'sms-notifications/meta',
    }),
  }),
});

export const {
  useGetSmsNotificationsQuery,
  useGetSmsNotificationSummaryQuery,
  useGetSmsNotificationMetaQuery,
} = smsNotificationApi;
